import { clsx } from 'clsx';
import DisclosureRightSmallIcon from '../../../../icons/react/icon-disclosure-right-small';
import type { TableColumnDef } from '../column';
import styles from './row-expander.module.scss';

export function allRowsCanExpand() {
  return true;
}

export const RowExpander: TableColumnDef<any> = {
  id: 'expander',
  isActionColumn: true,
  header: () => <span aria-hidden>&zwnj;</span>,
  cell: ({ row }) => {
    const isExpanded = row.getIsExpanded();
    const toggleExpand = row.getToggleExpandedHandler();

    return row.getCanExpand() ? (
      <button
        aria-label={isExpanded ? 'Collapse row' : 'Expand row'}
        className={clsx(styles.rowExpander, isExpanded && styles.isExpanded)}
        onClick={toggleExpand}
        type="button"
      >
        <span className={styles.icon}>
          {isExpanded ? <DisclosureRightSmallIcon aria-hidden width={16} /> : <DisclosureRightSmallIcon aria-hidden width={16} />}
        </span>
      </button>
    ) : null;
  },
  enableSorting: false,
  enableMultiSort: false,
  enableHiding: false,
  enableColumnFilter: false,
  enableGlobalFilter: false,
  enableGrouping: false,
  enablePinning: false,
  enableResizing: false,
  maxSize: 32,
  size: 32,
  minSize: 32,
};
